import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { createAdmin, createUser, getUser } from './action';
import { AccountResponseDto, ValueOf } from 'types/types';
import { DataStatus } from 'types/enums';

type State = {
  status: ValueOf<typeof DataStatus>;
  createAdminStatus: ValueOf<typeof DataStatus>;
  token: string | null;
  data: null | AccountResponseDto;
};

const initialState: State = {
  token: null,
  data: null,
  status: DataStatus.IDLE,
  createAdminStatus: DataStatus.IDLE,
};

const { reducer, actions } = createSlice({
  initialState,
  name: 'user',
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.token = null;
      state.data = null;
    },
    setUser: (state, action) => {
      state.data = action.payload;
      state.status = DataStatus.SUCCEEDED;
    },
    clearUser: (state) => {
      state.token = null;
      state.data = null;
      state.status = DataStatus.IDLE;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUser.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.data = payload;
    });
    builder.addCase(createUser.fulfilled, (state, { payload }) => {
      state.data = payload;
    });
    builder.addCase(getUser.pending, (state) => {
      state.status = DataStatus.LOADING;
    });
    builder.addCase(getUser.rejected, (state) => {
      state.status = DataStatus.FAILED;
    });
    builder.addCase(createAdmin.fulfilled, (state) => {
      state.createAdminStatus = DataStatus.SUCCEEDED;
    });
    builder.addCase(createAdmin.pending, (state) => {
      state.createAdminStatus = DataStatus.LOADING;
    });
    builder.addCase(createAdmin.rejected, (state) => {
      state.createAdminStatus = DataStatus.FAILED;
    });

    builder.addMatcher(isAnyOf(getUser.pending, getUser.rejected, createUser.pending, createUser.rejected), (state) => {
      state.data = null;
    });
  },
});

export { actions, reducer };
